import { lazy } from "react";


function load(code){
    switch (code) {
        case "reward/editor":
            return lazy(() => import("views/reward/editor"));
        default:
            return null;
    }
}
export default load;